module.exports = __webpack_public_path__ + "static/img/corporate-credit1.8ae212b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/corporate-credit1.jpg
// module id = S3+B
// module chunks = 0